import { toRaw } from 'vue'
import { z } from 'zod'

type anything = string | string[] | number | number[] | null | boolean

interface FormItem {
  field: anything
  zod: object
}

export const extractZodFromForm = (form: FormItem[]): Record<string, object> => {
  return Object.fromEntries(
    form.map((v) => {
      return [v.field, toRaw(v.zod)]
    }),
  )
}

export const extractFormData = (form: FormItem[]): Record<string, anything> => {
  return Object.fromEntries(
    form.map((v) => {
      return [v.field, null]
    }),
  )
}

export const zodNumber = (z_: typeof z) => {
  return z_.preprocess((x) => (x === '' ? null : Number(z_)), z_.number().optional().nullable())
}
